import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/airplane.jpeg";

function TransportReiseliv() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.transportTravel.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.transportTravel.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/trygghet-pa-reisen-tydelig-kommunikasjon"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.transportTravel.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.transportTravel.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.transportTravel.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full object-cover"
            alt={i18next.t("pages.articles.list.transportTravel.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://pixabay.com/no/users/rolandmey-3495227/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=8607152"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Roland Mey
            </a>{" "}
            {i18next.t("pages.articles.credit.from")}{" "}
            <a
              href="https://pixabay.com/no/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=8607152"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pixabay
            </a>
          </p>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p>
              {i18next.t("pages.articles.list.transportTravel.sections.intro.content1")}
              <a href="/artikler/gjor-dokumentene-dine-tilgjengelige" className="underline hover:text-contrast-ink font-bold">
                {i18next.t("pages.articles.list.transportTravel.sections.intro.link")}
              </a>
              {i18next.t("pages.articles.list.transportTravel.sections.intro.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.transportTravel.sections.whenNotReach.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.transportTravel.sections.whenNotReach.content")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.transportTravel.sections.advantage.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.transportTravel.sections.advantage.content")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.transportTravel.sections.howHelp.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.transportTravel.sections.howHelp.content1")}
              <a href="/docengine" className="underline hover:text-contrast-ink font-bold">
                {i18next.t("pages.articles.list.transportTravel.sections.howHelp.link")}
              </a>
              {i18next.t("pages.articles.list.transportTravel.sections.howHelp.content2")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.transportTravel.sections.howHelp.content3")}
            </p>

            <p className="mt-8">
              {i18next.t("pages.articles.list.transportTravel.sections.cta.content")}{" "}
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.transportTravel.sections.cta.link")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransportReiseliv;


